import useVault from '@/application/read/vaults/useVault';
import AssetCard from '@/presentation/components/modules/AssetCard';
import { Asset } from 'nftx.js';

const MarketplaceAsset = ({
  id,
  assetAddress,
  tokenId,
  vaultIds,
  selected,
  onClick,
  imageUrl,
  dateAdded,
  disabled,
  rarity,
  rarityRank,
  quantity,
  selectedQuantity,
  onQuantityChange,
}: Asset & {
  selected?: boolean;
  onClick: () => void;
  disabled?: boolean;
  selectedQuantity: number;
  onQuantityChange: (quantity: number) => void;
}) => {
  const assetVaultId = vaultIds[0];
  const { data: vault } = useVault({
    vaultId: assetVaultId,
  });

  return (
    <AssetCard
      key={id}
      assetAddress={assetAddress}
      onClick={onClick}
      price={vault?.prices?.[0].redeem.price || undefined}
      tokenId={tokenId}
      selected={selected}
      disabled={disabled}
      imageUrl={imageUrl}
      dateAdded={dateAdded}
      vaultId={assetVaultId}
      rarity={rarity}
      rarityRank={rarityRank}
      is1155={!!vault?.is1155}
      quantity={quantity}
      onQuantityChange={onQuantityChange}
      selectedQuantity={selectedQuantity}
    />
  );
};

export default MarketplaceAsset;
